import React,  { useMemo, useRef, useState } from "react"

//model
import { IndustryType } from "../../../interfaces/Industry";

//components
import { BasicButton, IconLibrary, ISelectButton, SelectButtonList, ThriveIcon } from "thrive-components";

//hooks
import { useClickAwayClose } from "../../../utils/hooks/useClickawayClose";

//interface
import { ISelectIndustry } from "../../../interfaces/FormInputs";



const SelectIndustry = ({
    industry,
    setIndustry,
    validateIndustry,
    showError
}: ISelectIndustry) => {
    const [showIndustryDropdown, setShowIndustryDropdown] = useState<boolean>(false);
    const dropdownRef = useRef<HTMLDivElement | null>(null);

    const industryDropdown: ISelectButton[] = useMemo(() => {
        return Object.entries(IndustryType).map(([key, value]) => ({
            content: value,
            onClick: () => {
                setIndustry(key as IndustryType);
                setShowIndustryDropdown(false);
            },
            isSelected: industry === key,
            key,
        }));
    }, [industry]);

    useClickAwayClose(
        showIndustryDropdown,
        dropdownRef as React.RefObject<HTMLElement>,
        () => {setShowIndustryDropdown(false), validateIndustry()}
    );
    
    return (
        <>
        <div className={`select-industry input-wrapper ${showError ? "error-styling" : ""}`} ref={dropdownRef}>
            <span className="select-industry-label">
                Industry
            </span>

            <BasicButton
                className={`select-industry-button`}
                ariaLabel={"Select your workspace's industry"} 
                onButtonClick={() => setShowIndustryDropdown(!showIndustryDropdown)}
                content={
                    IndustryType[industry] || 
                    <>
                        Select an industry
                        
                        <ThriveIcon 
                            iconName={IconLibrary.CHEVRON_DOWN}
                            className="down-caret"
                            color="var(--thriveGreyDark)"
                            sizeInPx="12"
                        />
                    </>
                } 
            />

            {showError &&
                <span className="error-indicator">
                    Industry is required
                </span>
            }

            {showIndustryDropdown && 
                <SelectButtonList
                    buttons={industryDropdown}
                    className="industry-select-button-list" 
                    allButtonOnClick={() => setShowIndustryDropdown(false)}
                />
            }
        </div>
        </>
    )
}

export default SelectIndustry